import { render, staticRenderFns } from "./Compose.TemplateOptions.vue?vue&type=template&id=7a45db95&scoped=true&"
import script from "./Compose.TemplateOptions.vue?vue&type=script&lang=js&"
export * from "./Compose.TemplateOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a45db95",
  null
  
)

export default component.exports